export default class Api {
    constructor(baseUrl = 'gapi') {
        this.baseUrl = baseUrl;
    }

    async get(endpoint, options = {}) {
        const response = await fetch(this.baseUrl + endpoint, {
            method: 'GET',
            ...options,
        });
        return this._handleResponse(response);
    }

    async post(endpoint, data = {}, options = {}) {
        const response = await fetch(this.baseUrl + endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(options.headers || {}),
            },
            body: JSON.stringify(data),
            ...options,
        });
        return this._handleResponse(response);
    }

    async put(endpoint, data = {}, options = {}) {
        const response = await fetch(this.baseUrl + endpoint, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...(options.headers || {}),
            },
            body: JSON.stringify(data),
            ...options,
        });
        return this._handleResponse(response);
    }

    async delete(endpoint, options = {}) {
        const response = await fetch(this.baseUrl + endpoint, {
            method: 'DELETE',
            ...options,
        });
        return this._handleResponse(response);
    }

    _handleResponse(response) {
        if (!response.ok) {
            return response.text().then(text => {
                let responseData = JSON.parse(text) || {};
                if (responseData.code === 401) {
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 1000);
                }
                throw new Error(text || response.statusText);
            });
        }
        return response.json().catch(() => null);
    }
}